














import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import ICity from '../interface/ICity';
import userInterface from '../interface/user';

@Component({
  computed: {
    ...mapGetters(['getUsers', 'getCurrentColor', 'getCompletedLength']),
  },
})
export default class City extends Vue {
  @Prop({ default: [] }) private city!: ICity;

  @Prop({ default: [] }) show!: boolean;

  @Prop({ default: [] }) private isUserActive!: boolean;

  getCurrentColor!: string

  getUsers!: userInterface[];

  isHover = false;
}
